  import { headers, url } from "./const";
  const regex = /^(0[1-9]|[12]\d|30)$/;
  const regexRuns = /^(0[1-9]|[12]\d|30)[+-]$/;
  const regexRl = /^(0[1-9]|[12]\d|30)[Rr]$/;
  const regexP = /^(0[1-9]|[12]\d|30)[Pp]$/;
  const regexK = /^(0[1-9]|[12]\d|30)[Kk][+-]$/;
  const regexS = /^(0[1-9]|[12]\d|30)[Ss][+-]$/;
  const splitSecondCapital = (str) => {
    return str.replace(/^([A-ZÁÉÍÓÚÜa-záéíóúü])[a-záéíóúü]*([A-ZÁÉÍÓÚÜ].*)$/, "$1 $2");
  };
 export const handleGetBet = (bet, betted, program, amountBet) => {
      if (bet !== "" && betted.length<=10) {
        const thisBetInput = bet;
        const option = thisBetInput;
        let thisBetCode = "";
        if (thisBetInput.trim().split("").length == 2) {
          thisBetCode = thisBetInput.trim();
        } else if (thisBetInput.trim().split("").length == 3) {
          thisBetCode = thisBetInput.split("").slice(0, -1).join("").toUpperCase();
        } else if (thisBetInput.trim().split("").length == 4) {
          thisBetCode = thisBetInput.split("").slice(0, -2).join("").toUpperCase();
        } else {
          alert("Jugada No Valida");
        }
        const gameThisBet = program.find((item) => item.home.team == thisBetCode || item.away.team == thisBetCode);
        let rate;
        if (regex.test(option)) {
          if (option == gameThisBet.home.team) {
            gameThisBet.betted = gameThisBet.home.symbol + " (Juego)";
            rate = gameThisBet.home.rate;
          }
          if (option == gameThisBet.away.team) {
            gameThisBet.betted = gameThisBet.away.symbol + " (Juego)";
            rate = gameThisBet.away.rate;
          }
          gameThisBet.code = gameThisBet.idGame + "1";
        } else if (regexRl.test(option)) {
          const thisOption = option.replace(/r/i, "");
          if (thisOption == gameThisBet.home.team) {
            gameThisBet.betted = gameThisBet.home.rl.da ? gameThisBet.home.symbol + " (RL) " + "-1.5" : gameThisBet.home.symbol + " (RL) " + "+1.5";
            rate = gameThisBet.home.rl.rate;
          }
          if (thisOption == gameThisBet.away.team) {
            gameThisBet.betted = gameThisBet.away.rl.da ? gameThisBet.away.symbol + " (RL) " + "-1.5" : gameThisBet.away.symbol + " (RL) " + "+1.5";
            rate = gameThisBet.away.rl.rate;
          }

          gameThisBet.code = gameThisBet.idGame + "1";
        } else if (regexP.test(option)) {
          const thisOption = option.replace(/p/i, "");
          if (thisOption == gameThisBet.home.team) {
            gameThisBet.betted = gameThisBet.home.rl.da ? gameThisBet.home.symbol + " (P) " + "-2.5" : gameThisBet.home.symbol + " (P) " + "+2.5";
            rate = gameThisBet.home.p.rate;
          }
          if (thisOption == gameThisBet.away.team) {
            gameThisBet.betted = gameThisBet.away.rl.da ? gameThisBet.away.symbol + " (P) " + "-2.5" : gameThisBet.away.symbol + " (P) " + "+2.5";
            rate = gameThisBet.away.p.rate;
          }
          gameThisBet.code = gameThisBet.idGame + "1";
        } else if (regexRuns.test(option)) {
          gameThisBet.betted = gameThisBet.away.symbol + " (VS) " + gameThisBet.home.symbol + "  " + option.split("").at(-1) + gameThisBet.runs;
          rate = -12;
          gameThisBet.code = gameThisBet.idGame + "2";
        } else if (regexK.test(option)) {
          const thisOption = option;
          const teamPicher = thisOption.substring(0, 2);
          const thisBet = thisOption.at(-1);
          if (teamPicher == gameThisBet.away.team) {
            const picher = gameThisBet.away.picher.name;
            gameThisBet.betted = splitSecondCapital(picher.replace(/ /g, "")) + " (Ponches) " + thisBet + gameThisBet.away.k;
            rate = -12;
            gameThisBet.code = gameThisBet.idGame + "3";
          } else if (teamPicher == gameThisBet.home.team) {
            const picher = gameThisBet.home.picher.name;
            gameThisBet.betted = splitSecondCapital(picher.replace(/ /g, "")) + " (Ponches) " + thisBet + gameThisBet.home.k;
            rate = -12;
            gameThisBet.code = gameThisBet.idGame + "3";
          }
        } else if (regexS.test(option)) {
          const thisOption = option;
          const team = thisOption.substring(0, 2);
          const thisBet = thisOption.at(-1);
          if (team == gameThisBet.away.team) {
            gameThisBet.betted = gameThisBet.away.symbol + " (Solo) " + thisBet + gameThisBet.away.s;
            rate = -12;
            gameThisBet.code = gameThisBet.idGame + "1";
          } else if (team == gameThisBet.home.team) {
            gameThisBet.betted = gameThisBet.home.symbol + " (Solo) " + thisBet + gameThisBet.home.s;
            rate = -12;
            gameThisBet.code = gameThisBet.idGame + "1";
          }
        } else {
          return alert("La Jugada No es Valida");
        }

        if (!gameThisBet) return alert("La Jugada Digitada No es Valida");
        const thisBetted = {
          number: betted.length + 1,
          code: gameThisBet.code,
          option: option,
          rate,
          betted: gameThisBet.betted,
        };

        if ((!thisBetted.option.toUpperCase().includes("K") && betted.some((item) => item.code === thisBetted.code)) || (thisBetted.option.toUpperCase().includes("K") && betted.some((item) => item.betted.includes(splitSecondCapital(thisBetted.betted.split("(Ponches)")[0].trim().replace(/ /g, "")))))) {
        return  alert("Jugada repetida o Contradictoria");
        } else {
          betted.push(thisBetted);
          return betted
        }
      } else {
        if (betted.length >= 3 && betted.length <= 12) {
          if (amountBet == "") amountBet = "50";
          const monto = parseFloat(amountBet);
          return (betted.reduce((acum, current) => acum * (1 + (current.rate < 0 ? (-1 * 10) / current.rate : current.rate / 10)), monto));
        } else {
          alert("La jugada debe estar comprendida entre tripleta y octava");
        }
      }
    
  };
  
  export const handleGetAmountBet = async (amountBet, amountWin, betted, evento) => {
        if (amountBet && amountBet !== "" && amountBet > 0 && parseFloat(amountWin)<100000) {
          const amount =amountBet;
          try {
            const res = await fetch(`${url}/ticket`, {
              method: "post",
              headers: headers,
              body: JSON.stringify({
                betted,
                amount,
                event: evento,
                amountToWin: amountWin,
              }),
            });
            const data = await res.json();  
            if (data.msg === "ok") {
              if (data.ticket) {
              }
            }else{
            return 'Monto Superado'
            }
          } finally {
            return 'Ticket Creado'
          }
        } else {
          return "Monto no Valido o Monto a Ganar superado";
        }
      
    };